export default {"src":"/_next/static/media/legal-document.175f9435.svg","height":46,"width":46,"blurWidth":0,"blurHeight":0};